import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import BillActionButton from '../BillActionButton'
import UpdatePayeeButton from '../UpdatePayeeButton'
import {hasMissingPayeeDetails} from '../payeeDetails'

const ActionCell = ({row, column}) => {
  const {onSelectPayee} = column.columnDef.meta

  return (
    <Box width="100%" textAlign="right">
      {!hasMissingPayeeDetails(row.original.payee) ? (
        <BillActionButton bill={row.original} />
      ) : (
        <UpdatePayeeButton
          payee={row.original.payee}
          onSelectPayee={onSelectPayee}
        />
      )}
    </Box>
  )
}

ActionCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      payee: PropTypes.shape({}),
    }).isRequired,
  }).isRequired,
  column: PropTypes.shape({
    columnDef: PropTypes.shape({
      meta: PropTypes.shape({
        onSelectPayee: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

export default ActionCell
